import { useAuth } from "@laborelec/lbe-react/auth";

/**
 * Role split driving the two top-level views.
 * A client is confined to the read-only dashboard; everyone else keeps the expert app.
 */
export function useRoles() {
  const { isUser } = useAuth();
  const isSuperUser = isUser("super_user");
  const isClient = isUser("client");
  return {
    isClient,
    isSuperUser,
    isAdmin: isUser("admin") || isSuperUser,
    isExpert: !isClient,
  };
}
